import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_CUSTOMERS: string = '[ecommerce customers] Load Ecommerce Customers';
export const LOAD_ECOMMERCE_CUSTOMERS_SUCCESS: string = '[ecommerce customers] Load Ecommerce Customers Success';
export const LOAD_ECOMMERCE_CUSTOMERS_FAIL: string = '[ecommerce customers] Load Ecommerce Customers Fail';

export const LOAD_ECOMMERCE_CUSTOMER: string = '[ecommerce customer] Load Ecommerce Customer';
export const LOAD_ECOMMERCE_CUSTOMER_SUCCESS: string = '[ecommerce customer] Load Ecommerce Customer Success';
export const LOAD_ECOMMERCE_CUSTOMER_FAIL: string = '[ecommerce customer] Load Ecommerce Customer Fail';

export class LoadEcommerceCustomers implements Action {
  readonly type: string = LOAD_ECOMMERCE_CUSTOMERS;

  constructor(public payload: { websiteId: number, search?: string, status?: string }) {
  }
}

export class LoadEcommerceCustomersSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_CUSTOMERS_SUCCESS;

  constructor(public payload: { websiteId: number; entities: any; customersCount: number }) {
  }

}

export class LoadEcommerceCustomersFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_CUSTOMERS_FAIL;

  constructor(public payload: any) {
  }

}

export class LoadEcommerceCustomer implements Action {
  readonly type: string = LOAD_ECOMMERCE_CUSTOMER;

  constructor(public payload: { websiteId: number, id: number }) {
  }
}

export class LoadEcommerceCustomerSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_CUSTOMER_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    entities: any,
  }) {
  }

}

export class LoadEcommerceCustomerFails implements Action {

  readonly type: string = LOAD_ECOMMERCE_CUSTOMER_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceCustomersAction =
  LoadEcommerceCustomers
  | LoadEcommerceCustomersSuccess
  | LoadEcommerceCustomersFails
  | LoadEcommerceCustomer
  | LoadEcommerceCustomerSuccess
  | LoadEcommerceCustomerFails;
